// Single place for brand + destinations. Safe to edit without touching components.

export const BRAND = {
    name: "SacredSpace",
    full: "SacredSpace: Through The Cosmic Lens",
    quizTitle: "WHY THE FUCK DO I DO THAT?",
    tagline: "A behavior-first cosmic pattern decoder.",
};

// Where the "DECODE MY CHART" button sends people once there is a destination.
// Leave "" to show the graceful not-wired-yet state.
export const CHART_DECODER_URL = "";

export const RESULT_PATH = (slug) => `/r/${slug}`;

export function buildShareUrl(slug) {
    if (typeof window === "undefined") return "";
    return `${window.location.origin}/r/${slug}`;
}
